import { Box, ButtonBase, CircularProgress, Grid, useMediaQuery, IconButton, FormControlLabel, Radio } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../components/Common/DeleteModal";
import Notification from "../../components/Common/Notification";
import PopOverFilter from "../../components/Common/PopoverFilter";
import SearchBar from "../../components/Common/Searchbar";
import Table from "../../components/Common/Table";
import TablePageControl from "../../components/Common/TablePageControl";
import CustomButton from "../../components/Form/CustomButton";
import CustomSelect2 from "../../components/Form/CustomSelect2";
import Helpers from "../../helpers/helpers";
import { deleteInventory, getInventoryDetails, getInventoryListing, getInventoryFilters, updateInventory, resetInventoryActionState } from "../../store/actions";
import InventoryDetailsDialog from "./InventoryDetailsDialog";
import { Container } from "reactstrap";
import { Icon } from "@iconify/react/dist/iconify.js";
import AppTab from "../../components/Common/AppTab";
import Label from "../../components/Common/Label";
import LoadingDialog from "../../components/Common/LoadingDialog";
import moment from "moment";
import AppDialog from "../../components/Common/AppDialog";
import RadioButtonGroupInGrid from "../../components/Form/RadioButtonGroupInGrid";

const statusOptions = [
  { value: "in_stock", label: "In Stock" },
  { value: "sold_out", label: "Sold" },
  { value: "rental", label: "Rental" },
  { value: "scrapped", label: "Scrapped" },
  { value: "unpublish", label: "Unpublished" },
];

const normaliseFilterValue = (value) => {
  const normalise = (item) => String(item).trim().toLowerCase().replace(/\s+/g, "_");
  return Array.isArray(value) ? value.filter((item) => item !== "all").map(normalise) : value ? normalise(value) : "";
};

const Inventory = ({ inventoryFilters, verifyAdmin, currentUser, inventory, updateInventoryArry, inventoryDetails, inventoryDelete, inventoryError, isDirectSeller }) => {
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState(null);
  const [deleteItem, setDeleteItem] = useState(null);
  const isMobile = useMediaQuery("(max-width:768px)");
  const [search, setSearch] = useState("");
  const [tab, setTab] = useState("all");
  const [page, setPage] = useState(1);
  const [length, setLength] = useState(10);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [sort, setSorted] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [sort_by, setSortBy] = useState("");
  const [filterVersion, setFilterVersion] = useState(0);
  const [assignDealerOpen, setAssignDealerOpen] = useState(0);
  const [isAccessibleDealersLoading, setIsAccessibleDealersLoading] = useState(false);
  const [accessibleDealerSearch, setAccessibleDealerSearch] = useState("");
  const [notification, setNotification] = useState({ open: false, msg: "", type: "success" });
  const [selectedRow, setSelectedRow] = useState({});
  const searchRef = useRef(search);
  const accessibleDealersRequestRef = useRef(null);

  useEffect(() => {
    if (isDirectSeller)
      navigate("/not-found")
  }, [])

  useEffect(() => {
    dispatch(getInventoryFilters());
    dispatch(resetInventoryActionState());
  }, []);

  useEffect(() => {
    if (!updateInventoryArry?.code) return;
    setIsLoading(false);
    if (updateInventoryArry?.code === "success") {
      setNotification({ open: true, msg: updateInventoryArry?.message || "Inventory updated successfully.", type: "success" });
      setAssignDealerOpen(false);
      initData();
    } else {
      setNotification({
        open: true,
        msg: updateInventoryArry?.message || (updateInventoryArry?.errors ? "Please fill all required fields." : "Unable to update inventory."),
        type: "error",
        errors: updateInventoryArry?.errors,
      });
    }
    dispatch(resetInventoryActionState());
  }, [updateInventoryArry]);

  useEffect(() => {
    searchRef.current = search || '';
  }, [search]);

  useEffect(() => {
    if (inventory?.code && inventory?.code === "success") {
      setIsLoading(false);
    } else if (inventory?.code && inventory?.code !== "success") {
      setIsLoading(false);
    }
  }, [inventory]);

  useEffect(() => {
    if (selectedItem && inventoryDetails?.code === "success") {
      setSelectedItem(inventoryDetails?.data);
    }
  }, [inventoryDetails]);

  useEffect(() => {
    if (
      assignDealerOpen &&
      isAccessibleDealersLoading &&
      inventoryDetails !== accessibleDealersRequestRef.current
    ) {
      setIsAccessibleDealersLoading(false);
    }
  }, [assignDealerOpen, inventoryDetails, isAccessibleDealersLoading]);

  useEffect(() => {
    if (!inventoryDelete?.code) return;
    setIsLoading(false);

    if (inventoryDelete.code === "success") {
      setNotification({ open: true, msg: inventoryDelete.message || "Inventory deleted successfully.", type: "success" });
      setDeleteItem(null);
      setSelectedItem(null);
      setFilterVersion((version) => version + 1);
    } else {
      setNotification({ open: true, msg: inventoryDelete.message || "Unable to delete inventory.", type: "error" });
    }
    dispatch(resetInventoryActionState());
  }, [inventoryDelete]);

  useEffect(() => {
    if (!inventoryError || (Array.isArray(inventoryError) && inventoryError.length === 0)) return;
    setIsLoading(false);
    setNotification({
      open: true,
      msg: inventoryError?.message || inventoryError?.[0] || "Unable to delete inventory.",
      type: "error",
    });
  }, [inventoryError]);

  useEffect(() => {
    initData();
  }, [length, page, sort, sort_by, tab, filterVersion]);

  const currentAccount = verifyAdmin?.user?.data?.profile?.selected_dealer_id ? verifyAdmin?.user?.data?.profile?.active_dealer_users?.find(user => user.dealer_id === verifyAdmin?.user?.data?.profile?.selected_dealer_id) : currentUser;
  const dispatch = useDispatch();

  const emptyFilters = {
    inventory_type: "all",
    source: "all",
    bike_make_ids: [],
    bike_model_ids: [],
    bike_type_ids: [],
    purchase_price_min: "",
    purchase_price_max: "",
    suggested_price_min: "",
    suggested_price_max: "",
    license_category_ids: [],
    stock_status: [],
  };
  const initData = () => {
    setIsLoading(true);
    dispatch(getInventoryListing({
      page: page,
      length: length,
      sort: sort,
      sort_by: sort_by,
      search: searchRef.current,
      tab: tab,
      inventory_type: normaliseFilterValue(filterObject?.inventory_type),
      source: filterObject?.source === "all" ? "" : normaliseFilterValue(filterObject?.source),
      bike_make_ids: filterObject?.bike_make_ids || [],
      bike_model_ids: filterObject?.bike_model_ids || [],
      bike_type_ids: normaliseFilterValue(filterObject?.bike_type_ids),
      purchase_price_min: filterObject?.purchase_price_min || "",
      purchase_price_max: filterObject?.purchase_price_max || "",
      suggested_price_min: filterObject?.suggested_price_min || "",
      suggested_price_max: filterObject?.suggested_price_max || "",
      license_category_ids: normaliseFilterValue(filterObject?.license_category_ids || ""),
      stock_status: normaliseFilterValue(filterObject?.stock_status || ""),
    }))
  }


  const [filterObject, setFilterObject] = useState(emptyFilters);

  const inventoryItems = inventory?.data?.data || [];
  const accessibleDealers = inventoryDetails?.data?.accessible_dealers || [];
  const filteredAccessibleDealers = accessibleDealers.filter((dealer) =>
    String(dealer?.company_name || "")
      .toLowerCase()
      .includes(accessibleDealerSearch.trim().toLowerCase())
  );

  const tabs = [
    ...statusOptions.map((item) => ({
      value: item.value,
      label: `${item.label} (${inventory?.counts?.[item.value] || 0})`,
    })),
    { value: "all", label: `All (${inventory?.counts?.all || inventoryItems.length})` },
  ];

  const money = (value) =>
    value ? `$${Number(value || 0).toLocaleString("en-SG", { minimumFractionDigits: 2 })}` : "$0.00";

  const showAccessibleDealer = currentAccount?.is_under_partnership && currentAccount?.is_erp_shared;

  const renderAccessibleDealer = (item, isMobileLayout = false) => (
    <div>
      {isMobileLayout && <div className="subheader-2 font-size-12">Accessible Dealer</div>}
      <div className="text-semibold d-flex align-items-center" style={{ color: "#071A3A" }}>
        {item.assigned_location?.company_name || "-"}
        <IconButton
          size={isMobileLayout ? "small" : "medium"}
          aria-label="Edit accessible dealer"
          onClick={(e) => {
            e.stopPropagation();
            accessibleDealersRequestRef.current = inventoryDetails;
            setIsAccessibleDealersLoading(true);
            setAccessibleDealerSearch("");
            setAssignDealerOpen(true);
            setSelectedRow(item);
            dispatch(getInventoryDetails({ id: item.id }));
          }}
        >
          <Icon icon="ri:pencil-line" width={18} height={18} />
        </IconButton>
      </div>
    </div>
  );

  const accessibleDealerColumn = {
    Header: "Accessible Dealer",
    accessor: (item) => renderAccessibleDealer(item),
    minWidth: 180,
  };

  const header = [
    {
      Header: "Reg. No",
      accessor: (item) => item?.register_number || "-",
      minWidth: 95,
    },
    {
      Header: "Vehicle",
      accessor: (item) => (
        <div>
          <div className="text-semibold" style={{ color: "#071A3A" }}>
            {item.vehicle || `${item.bike_make_ids || ""} ${item.model || ""}`}
          </div>
          <span
            style={{
              color:
                item.inventory_type?.toLowerCase() === "new"
                  ? "#2777C8"
                  : item.inventory_type?.toLowerCase() === "used"
                    ? "#FF7900"
                    : "#7D858C",
            }}
          >
            {item.inventory_type?.toLowerCase() === "new"
              ? "New"
              : item.inventory_type?.toLowerCase() === "rental"
                ? "Rental"
                : "Used"}
          </span>
          <span className="subheader-2">
            {" "}
            {item?.manu_year ? `• ${item?.manu_year}` : ""} {item?.body_type ? `• ${item?.body_type}` : ""} {" "}
            {item.engine_cc ? `• ${item.engine_cc}cc` : ""}
          </span>
        </div>
      ),
      minWidth: 245,
    },
    {
      Header: "COE Expiry",
      accessor: (item) => item.coe_expiry ? moment(item.coe_expiry, "YYYY-MM-DD").format("DD MMM YYYY") : "-",
      minWidth: 130,
    },
    {
      Header: "Source",
      accessor: (item) => item.source || "-",
      minWidth: 85,
    },
    {
      Header: "Status",
      accessor: (item) => (
        <Label.GeneralStatusLabel
          label={Helpers?.normaliseStatus(item.stock_status)}
          list={Helpers?.statusLabels}
          marginLeft="0"
        />
      ),
      minWidth: 180,
    },
    {
      Header: "Suggested Price",
      accessor: (item) => money(item.suggested_price || 0),
      minWidth: 140,
    },
    {
      Header: "Created by",
      accessor: (item) => (
        <div>
          <div className="text-semibold" style={{ color: "#071A3A" }}>
            {item.creator_name || item.created_by}
          </div>
          <span className="subheader-2">{item.created_at ? moment(item.created_at).format("DD MMM YYYY") : "-"}</span>
        </div>
      ),
      minWidth: 155,
    },
  ];

  const inventoryHeader = showAccessibleDealer
    ? [...header.slice(0, 2), accessibleDealerColumn, ...header.slice(2)]
    : header;

  const resetPage = (callback) => (value) => {
    callback(value);
    setPage((prevPage) => (prevPage === 1 ? '1' : 1));
  };

  const filterList2 = [
    {
      label: "Vehicle Type",
      type: "checkbox",
      value: filterObject?.inventory_type || "all",
      data: inventoryFilters?.inventory_types,
      xsGrid: 12,
      mdGrid: 12,
      onChange: (e, item) => {
        setFilterObject((prevValues) => ({
          ...prevValues,
          inventory_type: e,
        }))
      }
    },
    {
      label: "Source",
      type: "checkbox",
      value: filterObject?.source || [],
      data: inventoryFilters?.sources || [],
      xsGrid: 12,
      mdGrid: 12,
      onChange: (e, item) => {
        setFilterObject((prevValues) => ({
          ...prevValues,
          source: e,
        }))
      }
    },
    {
      label: "Make",
      type: "checkbox",
      value: filterObject?.bike_make_ids || [],
      data: inventoryFilters?.makes || [],
      xsGrid: 12,
      mdGrid: 12,
      onChange: (e, item) => {
        setFilterObject((prevValues) => ({
          ...prevValues,
          bike_make_ids: e,
        }))
      }
    },
    {
      label: "Model",
      type: "checkbox",
      value: filterObject?.bike_model_ids || [],
      data: inventoryFilters?.models || [],
      xsGrid: 12,
      mdGrid: 12,
      onChange: (e, item) => {
        setFilterObject((prevValues) => ({
          ...prevValues,
          bike_model_ids: e,
        }))
      }
    },
    {
      label: "Body Type",
      type: "checkbox",
      value: filterObject?.bike_type_ids || [],
      data: inventoryFilters?.bike_types || [],
      xsGrid: 12,
      mdGrid: 12,
      onChange: (e, item) => {
        setFilterObject((prevValues) => ({
          ...prevValues,
          bike_type_ids: e,
        }))
      }
    },
    {
      label: "Purchase Price",
      type: "priceRange",
      // defaultMax: inventoryFilters?.price_ranges?.purchase_price?.max,
      minValue: filterObject?.purchase_price_min || "",
      maxValue: filterObject?.purchase_price_max || "",
      prefix: "$",
      setMinAmount: (value) => {
        setFilterObject({ ...filterObject, purchase_price_min: value })
      },
      setMaxAmount: (value) => {
        setFilterObject({ ...filterObject, purchase_price_max: value })
      },
    },
    {
      label: "Suggested Price",
      type: "priceRange",
      // defaultMax: inventoryFilters?.price_ranges?.suggested_price?.max,
      minValue: filterObject?.suggested_price_min || "",
      maxValue: filterObject?.suggested_price_max || "",
      prefix: "$",
      setMinAmount: (value) => {
        setFilterObject({ ...filterObject, suggested_price_min: value })
      },
      setMaxAmount: (value) => {
        setFilterObject({ ...filterObject, suggested_price_max: value })
      },
    },
    {
      label: "License Category",
      type: "checkbox",
      value: filterObject?.license_category_ids || [],
      data: inventoryFilters?.license_categories || [],
      xsGrid: 12,
      mdGrid: 12,
      onChange: (e, item) => {
        setFilterObject((prevValues) => ({
          ...prevValues,
          license_category_ids: e,
        }))
      }
    },
  ];

  const applyFilter = () => {
    setPage(1);
    setFilterVersion((version) => version + 1);
    setDrawerOpen(false);
  };
  const resetFilter = () => {
    setFilterObject(emptyFilters);
    setSortBy("");
    setSorted("");
    setSearch(""); // Clear search keyword
    searchRef.current = ""; // Update searchRef
    setFilterVersion((version) => version + 1);
    setDrawerOpen(false);
    setPage(page === 1 ? '1' : 1);
  };

  const deleteSelectedItem = () => {
    if (!deleteItem?.id) return;
    setIsLoading(true);
    dispatch(deleteInventory({ id: deleteItem.id }));
  };

  const openDetails = (item) => {
    setSelectedItem(item);
    dispatch(getInventoryDetails({ id: item.id }));
  };

  const handleSearch = (text) => {
    setSearch(text);
    setTimeout(() => {
      if (text === searchRef.current) {
        setPage(page === 1 ? '1' : 1);
      }
    }, Helpers.searchInterval);
  }

  const moreFilters = () => {
    return (
      <>
        <Grid item md={1.5} xs={7} mt={2}>
          <PopOverFilter
            setDialogOpen={setDrawerOpen}
            open={drawerOpen}
            applyFilter={applyFilter}
            filterData={filterList2}
            setFilterObject={setFilterObject}
            sort={sort}
            sort_by={sort_by}
            handleResetFilter={resetFilter}
          />
        </Grid>
        {!isMobile && <Grid item md={1.5} xs={5} mt={1.5} alignContent={"center"} justifyContent={"flex-end"}>
          <CustomButton
            title={<div style={{ textDecorationLine: 'underline' }}>Clear all</div>}
            press={() => resetFilter()}
            height={32}
            backgroundColor={'transparent'}
            textColor={'#B48A3C'}
            borderStyle={'none'}
          />
        </Grid>}
      </>
    )
  }

  const handleAssignDealer = (dealerId, assignedLocationId) => {
    setIsLoading(true);
    dispatch(updateInventory({ id: dealerId, data: { dealer_ids: [assignedLocationId] } }))
  }

  const handleAccessibleDealerChange = (dealerId) => {
    setSelectedRow((previousRow) => ({
      ...previousRow,
      assigned_location: {
        ...previousRow.assigned_location,
        id: dealerId,
      },
    }));
  };

  return (
    <div className="page-content">
      <LoadingDialog open={isLoading} />
      <Notification notification={notification} setNotification={setNotification} errors={notification.errors} />
      <Container fluid>
        <Box sx={{ display: !isMobile ? "block" : "none" }}>
          <div className="d-flex justify-content-between align-items-center p-1 pb-2">
            <div className="header-2 d-flex align-items-center">
              Inventory <div className="header-amount mx-2">{inventory?.data?.total || inventoryItems.length}</div>
            </div>
            <CustomButton
              title={
                <>
                  <i className="ri-add-line" style={{ marginRight: 5 }} />
                  Create new inventory
                </>
              }
              press={() => navigate("/inventory/create")}
              padding={20}
              height={40}
            />
          </div>

          <AppTab
            tabValue={tab}
            setTabValue={(value) => {
              setTab(value);
              setPage(1);
            }}
            tabList={tabs}
          />
        </Box>
        <Grid container spacing={1.25} alignItems="center" mb={2.5}>
          <Grid item xs={12} lg={5} md={5} mt={1.5}>
            <SearchBar
              value={search}
              setValue={(value) => {
                handleSearch(value);
              }}
              module="customer, vehicle"
            />
          </Grid>
          {!isMobile && <>
            <Grid item md={2} xs={4} mt={2}>
              <CustomSelect2
                values={filterObject?.inventory_type}
                onChange={resetPage((value) => setFilterObject(prev => ({ ...prev, inventory_type: value })))}
                module="Type"
                placeholder="Type: All"
                data={[{ value: "all", label: "All" }, ...(inventoryFilters?.inventory_types || [])]}
                startAdornment={
                  <div className="subheader-2" style={{ marginRight: 5 }}>
                    Type:
                  </div>
                }
              />
            </Grid>
            <Grid item md={2} xs={6} mt={2}>
              <CustomSelect2
                values={filterObject?.source}
                onChange={resetPage((value) => setFilterObject(prev => ({ ...prev, source: value })))}
                module="Source"
                placeholder="Source: All"
                data={[{ value: "all", label: "All" }, ...(inventoryFilters?.sources || [])]}
                startAdornment={
                  <div className="subheader-2" style={{ marginRight: 5 }}>
                    Source:
                  </div>
                }
              />
            </Grid>
            {moreFilters()}
          </>}
        </Grid>
        <Box sx={{ display: isMobile ? "none" : "block" }}>
          <Table
            header={currentAccount?.role_id === 3 ? inventoryHeader.slice(0, -1) : inventoryHeader}
            data={inventory?.data?.data || []}
            pageSize={Number(length)}
            onTableRowClick={openDetails}
          />
        </Box>

        {isMobile && <Box>
          <AppTab
            tabValue={tab}
            setTabValue={(value) => {
              setTab(value);
              setPage(1);
            }}
            tabList={tabs}
          />
          <div className="d-flex justify-content-between align-items-center p-1 pb-2">
            <div className="d-flex align-items-center text-semibold font-size-16">{inventory?.data?.total || 0} Listings</div>
            <ButtonBase style={{ borderRadius: '100%' }} onClick={() => navigate('/inventory/create')}>
              <Icon icon={'ri:add-circle-fill'} style={{ height: 28, width: 28 }} />
            </ButtonBase>
          </div>
          <Grid container>
            {moreFilters()}
          </Grid>

          {inventory?.data?.data?.length > 0 && inventory?.data?.data.map((item) => (
            <Box
              key={item.id}
              onClick={() => openDetails(item)}
              sx={{
                py: 2,
                borderBottom: "1px solid #E2E2E2",
                cursor: "pointer",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 1,
                }}
              >
                <div>
                  <div className="subheader-2 font-size-12">
                    {item.register_number || "Unregistered"}
                  </div>
                  <div className="text-semibold" style={{ color: "#071A3A", display: "flex", flexDirection: "row", alignItems: "center" }}>
                    {item.vehicle || `${item.make || ""} ${item.model || ""}`}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Label.GeneralStatusLabel
                        label={Helpers?.normaliseStatus(item.stock_status)}
                        list={Helpers?.statusLabels}
                        marginLeft="10px"
                      />
                    </Box>
                  </div>
                  <div className="subheader-2">
                    <span style={{ color: item.inventory_type?.toLowerCase() === "new" ? "#2777C8" : "#FF7900" }}>
                      {item.inventory_type || "-"}
                    </span>{" • "}
                    {item.manu_year || "-"} • {item.body_type || "-"} •{" "}
                    {item.engine_cc ? `${item.engine_cc}cc` : "-"}
                  </div>
                </div>
                <div className="text-semibold">{money(item.suggested_price)}</div>
              </Box>
              <Grid container spacing={1.25} mt={1.25}>
                <Grid item xs={6}>
                  <div className="subheader-2 font-size-12">Source</div>
                  <div>{item.source || "-"}</div>
                </Grid> <Grid item xs={6} textAlign="right">
                  <div className="subheader-2 font-size-12">COE Expiry</div>
                  <div>{item.coe_expiry ? moment(item.coe_expiry, "YYYY-MM-DD").format("DD MMM YYYY") : "-"}</div>
                </Grid>

                {showAccessibleDealer && (
                  <Grid item xs={12}>{renderAccessibleDealer(item, true)}</Grid>
                )}

                {currentAccount?.role_id !== 3 && (
                  <Grid item xs={12}>
                    <div className="subheader-2 font-size-12">Created by</div>
                    <div>{item.creator_name || item.created_by || "-"}</div>
                    <div className="subheader-2 font-size-12">
                      {item.created_at ? moment(item.created_at).format("DD MMM YYYY") : "-"}
                    </div>
                  </Grid>
                )}
              </Grid>
            </Box>
          ))}
        </Box>}

        <TablePageControl
          length={length}
          setLength={setLength}
          page={page}
          setPage={setPage}
          totalPage={inventory?.data?.last_page || 1}
        />
        <InventoryDetailsDialog
          open={Boolean(selectedItem)}
          close={() => setSelectedItem(null)}
          item={selectedItem}
          status={selectedItem ? Helpers?.normaliseStatus(selectedItem.stock_status) : ""}
          statusList={Helpers?.statusLabels}
          isMobile={isMobile}
          onDelete={() => {
            setDeleteItem(selectedItem);
            setSelectedItem(null);
          }}
          onEdit={() => navigate(`/inventory/${selectedItem?.id}/edit`)}
        />
        <DeleteModal
          open={Boolean(deleteItem)}
          close={() => setDeleteItem(null)}
          submit={deleteSelectedItem}
          title="Delete Inventory"
          width="420px"
          isMobile={isMobile}
          mobileSizeModalMaxHeight="70vh"
          message={
            <div>
              <div className="mb-3">
                Are you sure you want to delete this inventory entry?
              </div>
              <div className="text-semibold mb-2">Once deleted:</div>
              <div className="subheader-2 d-flex align-items-start">
                <span style={{ marginRight: 8 }}>•</span>
                <span>
                  The vehicle record will be permanently removed from your
                  inventory and cannot be undone.
                </span>
              </div>
            </div>
          }
        />
        <AppDialog
          open={assignDealerOpen}
          close={() => {
            setAssignDealerOpen(false);
            setIsAccessibleDealersLoading(false);
            setAccessibleDealerSearch("");
          }}
          title={"Assign Dealer Account"}
          positiveTitle={"Assign"}
          positivePress={() => { handleAssignDealer(selectedRow?.id, selectedRow?.assigned_location?.id) }}
          negativePress={() => { setAssignDealerOpen(false); setIsAccessibleDealersLoading(false); setAccessibleDealerSearch(""); dispatch(resetInventoryActionState()); setSelectedRow({}) }}
          negativeTitle={'Cancel'}
          width={'50%'}
          isMobile={isMobile}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div className="subheader-2">Please select the dealer account that can create an advert with this inventory.</div>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                position: "sticky",
                top: 0,
                zIndex: 2,
                backgroundColor: "white",
                paddingBottom: 1,
              }}
            >
              <SearchBar
                value={accessibleDealerSearch}
                setValue={setAccessibleDealerSearch}
                module="dealer name"
              />
            </Grid>

            {isAccessibleDealersLoading ? (
              <Grid item xs={12}>
                <Box className="d-flex align-items-center justify-content-center" sx={{ minHeight: 120, gap: 1.5 }}>
                  <CircularProgress size={24} />
                  <span>Loading accessible dealers...</span>
                </Box>
              </Grid>
            ) : filteredAccessibleDealers.length > 0 ? (
              filteredAccessibleDealers.map((type, index) => (
                  <Grid item xs={12} key={type.id || index}>
                    <div style={{ padding: "10px" }} className={`${selectedRow?.assigned_location?.id === type.id ? 'dashboard-selected-card' : 'dashboard-card'} d-flex align-items-center clickable`}
                      onClick={() => handleAccessibleDealerChange(type.id)}>
                      <Grid container spacing={2}>
                        <Grid item lg={11} sm={10} xs={9} display="flex" alignItems="center">
                          <div className="">{type?.company_name || '-'}</div>
                        </Grid>
                        <Grid item lg={1} sm={2} xs={3} className="d-flex align-items-center justify-content-end">
                          <FormControlLabel
                            checked={selectedRow?.assigned_location?.id === type.id}
                            value={type.id}
                            onChange={() => handleAccessibleDealerChange(type.id)}
                            onClick={(e) => e.stopPropagation()}
                            label=""
                            style={{ fontFamily: 'FunnelSans', fontSize: 14, margin: 0 }}
                            control={<Radio
                              sx={{
                                '&.Mui-checked': {
                                  color: "#1D1B1B",
                                },
                                '& .MuiSvgIcon-root': {
                                  fontSize: 20,
                                },

                              }} />}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <Box className="d-flex align-items-center justify-content-center" sx={{ minHeight: 120 }}>
                  {accessibleDealerSearch.trim() ? "No matching dealers found." : "No accessible dealers available."}
                </Box>
              </Grid>
            )}
          </Grid>
        </AppDialog>
      </Container>
    </div>
  );
};

function mapStateToProps({ Login, Inventory, Layout, General }) {
  return {
    width: Layout?.currentWidth,
    verifyAdmin: Login.verifyAdmin,
    currentUser: Login.verifyAdmin?.user?.data?.profile,
    isDirectSeller: Login?.verifyAdmin?.user?.data?.profile?.selected_dealer_id ? false : true,
    userPermission: Login.permissionArry,
    inventory: Inventory?.inventoryListing,
    inventoryDetails: Inventory?.inventoryDetails,
    leftSideBarType: Layout.leftSideBarType,
    inventoryFilters: Inventory?.inventoryFilters?.data,
    inventoryDelete: Inventory?.inventoryDelete,
    updateInventoryArry: Inventory?.inventoryEdit,
    inventoryError: Inventory?.error,
  };
}

export default connect(mapStateToProps)(Inventory);
